<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="50"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />

            <td class="data-table__cell">
              <router-link
                class="data-table__truncate"
                :title="item.title"
                :to="`/videos/${item.id}/edit`"
              >
                {{ item.title }}
              </router-link>
            </td>
            <td class="data-table__cell">
              <router-link
                class="data-table__truncate"
                :title="`${productionDomain}/${item.watch_url}`"
                :to="`/videos/${item.id}/edit`"
              >
                {{ productionDomain }}/{{ item.watch_url }}
              </router-link>
            </td>
            <td class="data-table__cell">
              {{ item.source_type == "vimeo" ? "Vimeo" : "Uploaded MP4" }}
            </td>
            <td class="data-table__cell">
              <a
                v-if="item.source_type == 'vimeo' && item.vimeo_url"
                class="data-table__truncate"
                :href="item.vimeo_url"
                :title="item.vimeo_url"
                target="_blank"
                rel="noopener noreferrer"
                @click.stop
              >
                {{ item.vimeo_url }}
              </a>
            </td>
            <td class="text-center nowrap">
              {{ (item.data && item.data.ctas && item.data.ctas.length) || 0 }}
            </td>
            <td class="text-center nowrap w0">
              <Actions
                hide-show
                hide-duplicate
                :path="`/videos/${item.id}`"
                @destroy="$emit('destroy', item)"
                @duplicate="$emit('duplicate', item)"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    productionDomain() {
      if (this.$isProjectSlug("ideasunited.com")) {
        return "https://new.ideasunited.com";
      }
      return `https://${this.currentUser?.production_domain}`;
    },
    headers() {
      return [
        {
          text: "Name",
          align: "start",
          value: "title",
          sortable: false,
        },
        {
          text: "URL",
          align: "start",
          value: "watch_url",
          sortable: false,
        },
        {
          text: "Source",
          align: "start",
          value: "source_type",
          sortable: false,
        },
        {
          text: "Vimeo URL",
          align: "start",
          value: "vimeo_url",
          sortable: false,
        },
        {
          text: "CTAs",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.data-table__cell {
  max-width: 280px;
}

.data-table__truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
